import { Injectable } from "@angular/core";
import { Configuration } from "./configuration";


@Injectable({
  providedIn: "root",
})
export class ConfigurationService {
  private configuration: Configuration;

  get(): Configuration {
    debugger
    return this.configuration;
  }

  async loadConfiguration(): Promise<void> {
    debugger
    const response = await fetch("/api/configuration");
    const configuration = await response.json();
    this.configuration = configuration;
    // console.log(this.configuration.test)
  }
  getAPIBaseUrl(): string {
    return this.configuration.apiEndpoint;
  }
  get subscriptionURL(): string {
    return this.configuration.subscriptionURL;
  }
  get apiEndpointforchecksubcription(): string {
    return this.configuration.apiEndpointforchecksubcription;
  }

  get acctSoftAPIurl(): any {
    return this.configuration.acctSoftAPIurl;
  }
  andicaCentralURL(): any {
    return this.configuration.andicaCentralURL;
  }
  environmentURL(): any {
    return this.configuration.environment;
  }
}
